<template>
  <div class="pdf-preview-sub-section-footer content-row"
       v-if="subSubSections.length > 0">
    <div class="item-no left"></div>
    <div class="item-group-footer"></div>
    <div class="item-price bottom"
         v-for="suffix in categorySuffix(itemCategories)"
         :key="suffix">
    </div>
    <div class="item-no right"></div>
  </div>
</template>

<script>

export default {
  name: 'SubSectionFooter',
  props: {
    subSection: Object,
    itemCategories: Array,
    subSubSections: Array,
  },
  setup() {
    const categorySuffix = function (categories) {
      let category_suffix = categories.map((category) => category.suffix);

      if (category_suffix.length === 0) {
        category_suffix = ['A']
      }

      return category_suffix;
    }

    return {
      categorySuffix,
    }
  }
}
</script>
